export const pages = {
  LOG_IN: '/auth/log-in',
  LOG_OUT: '/api/auth/log-out',
  LOGGED_OUT: '/auth/logged-out',
  ERROR: '/auth/error',
};
